import { useEffect, useState, useCallback } from 'react';
import { Row, Checkbox } from 'antd';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const PatientValidationPage = () => {
   const [validationData, setValidationData] = useState();
   const { search } = useLocation();
   const { t } = useTranslation();

   const getQueryParams = useCallback(() => {
      const findParams = new URLSearchParams(search);

      setValidationData(validationData => {return {...validationData, 'validationToken': findParams.get('validationToken')}});
   }, [search]);


   useEffect(() => {
      getQueryParams();
   }, [getQueryParams]);

   
   const handleValidation = () => {
      let message;

      if (validationData['validationToken'] !== 'false') {
         message = { 'identified': true };
      }

      window.opener && window.opener.postMessage(message, '*');
   };

   
   return (
      <Row justify="center">
         {t('admissionPage.patientValidationPage.patientValidation')}
         <Checkbox onClick={handleValidation} />
      </Row>
   );
};

export default PatientValidationPage;
